// @flow
import {
  MEDIA_ENGINE_TYPE_BUILT_IN,
  SERVER_STATE_STARTED,
  SERVER_STATE_STARTING,
  SERVER_STATE_STOPPED,
} from './constants';
import type { MediaEngine, ServerStatus } from 'state/types';

export const ADMIN_PROPERTIES = {
  backupConfig: 'backupsConfiguration',
  backupRestoreStatus: 'backupRestoreStatus',
  brandingSettings: 'brandingSettings',
  diagnosticDataStatus: 'diagnosticDataStatus',
  directoryServiceDescription: 'directoryServiceDescription',
  emailServerConfiguration: 'emailServerConfiguration',
  globalSettings: 'globalSettings',
  globalStatistics: 'globalStatistics',
  licenses: 'licenses',
  loggingConfig: 'loggingConfig',
  mediaEngines: 'mediaEngines',
  ports: 'ports',
  reachoutMessages: 'reachoutMessages',
  serverStatus: 'serverStatus',
};

export const BACKUP_OPERATION_STATE = {
  BACKUP_PREFLIGHT: 'BACKUP_PREFLIGHT',
  BACKUP_SHUTTING_DOWN_SERVER: 'BACKUP_SHUTTING_DOWN_SERVER',
  BACKUP_BACKING_UP_DATA: 'BACKUP_BACKING_UP_DATA',
  BACKUP_RESTARTING_SERVER: 'BACKUP_RESTARTING_SERVER',
  BACKUP_COMPLETE: 'BACKUP_COMPLETE',
  BACKUP_FAILED: 'BACKUP_FAILED',
  BACKUP_CANCELLED: 'BACKUP_CANCELLED',
  RESTORE_SHUTTING_DOWN_SERVER: 'RESTORE_SHUTTING_DOWN_SERVER',
  RESTORE_RESTORE_DATA: 'RESTORE_RESTORE_DATA',
  RESTORE_RESTARTING_SERVER: 'RESTORE_RESTARTING_SERVER',
  RESTORE_COMPLETE: 'RESTORE_COMPLETE',
  RESTORE_FAILED: 'RESTORE_FAILED',
  NONE: 'NONE',
};

export const BACKUP_RESTORE_FAULT_CODE = {
  INTERNAL_ERROR: 1,
  LIFECYCLE_ERROR: 2,
  BAD_ARCHIVE: 3,
  INSUFFICIENT_SPACE: 4,
  INVALID_BACKUP_DIRECTORY: 5,
};

export function calculateDiagnosticDataSendingStatus(
  newState?: string,
  oldState?: string,
  isSendingDiagnosticData: boolean
) {
  if (isSendingDiagnosticData && oldState !== newState) {
    return false;
  }
  return isSendingDiagnosticData;
}

export function calculateIsRestarting(
  newState?: ServerStatus,
  oldState?: ServerStatus,
  isRestarting: boolean
) {
  if (newState && oldState) {
    if (
      isRestarting &&
      (oldState.runState === SERVER_STATE_STOPPED &&
        (newState.runState === SERVER_STATE_STARTING ||
          newState.runState === SERVER_STATE_STARTED))
    ) {
      return false;
    }
  }
  return isRestarting;
}

export function sortMediaEngines(
  mes?: Array<MediaEngine>
): ?Array<MediaEngine> {
  // sort built-in first, then by address
  return (
    mes &&
    mes.sort((a, b) => {
      if (a.type === MEDIA_ENGINE_TYPE_BUILT_IN) {
        return -1;
      } else if (b.type === MEDIA_ENGINE_TYPE_BUILT_IN) {
        return 1;
      } else if (a.address && b.address) {
        return a.address.localeCompare(b.address);
      } else return -1;
    })
  );
}



// WEBPACK FOOTER //
// ./src/util/AdminProperties.js